import React, { Fragment, useEffect, useRef, useState } from "react";
import * as ReactDOM from "react-dom";
import { Badge, Card, CardBody, Col, FormGroup, Input, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import * as ReactDOMServer from "react-dom/server";
import JqxTable from "../../../../share-components/table/JqxTable";
import InfiniteScroll from "react-infinite-scroll-component";

/* eslint-disable jsx-a11y/anchor-is-valid */
const PartnerProductsJqx = (props) => {
  const {
    setValue,
    trigger,
    watch,
    getValues,
    partnerProducts,
    setButtonDisable,
    isDelete,
    infiniteScrollRef,
    fetchProductData,
    partnerPromotionState,
  } = props;
  let gridRef = useRef(null);
  let selectRef = useRef(null);
  const [products, setProducts] = useState([]);

  const ourPercentage = watch("percentage");

  useEffect(() => {
    if (partnerProducts && partnerProducts.length > 0) {
      setProducts((prev) => {
        if (partnerProducts.length > prev.length) {
          return partnerProducts; 
        } else {
          return partnerProducts; 
        }
      });
    }
  }, [partnerProducts]);

  const onDelete = (index) => {
    const newProducts = [...products];
    newProducts.splice(index, 1);
    setProducts(newProducts);
    setDataToHookForm(newProducts);
  };

  const setDataToHookForm = (data) => {
    setValue("promotion_products_new", data);
    trigger("promotion_products_new");

    setValue("promotion_products", data);
    trigger("promotion_products");
  };

  const calculatePriceAfterDiscount = (discount = 0,itemPrice, salePrice) => {
    let price = itemPrice === null ? salePrice : itemPrice;
    return +(price * (1 - discount / 100)).toFixed(2);
  };
  return (
    <Fragment>
      <div style={{ width: "100%" }}>
        <InfiniteScroll
          ref={(scroll) => {
            infiniteScrollRef.current = scroll;
          }}
          dataLength={products.length}
          next={fetchProductData}
          hasMore={partnerPromotionState.promotions_products.pagination.has_more}
          refreshFunction={() => {
            alert("Test");
          }}
          pullDownToRefresh={true}
          // onScroll={(e)=>{console.log(e)}}
          height={400}
          loader={<p>Loading...</p>}
        >
          <table
            className="table"
            style={{
              width: "100%",
              // height: 500,
              // overflowY: "scroll",
              display: "block",
              borderCollapse: "collapse",
              border: "1px solid #dee2e6",
            }}
          >
            <thead>
              <tr style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                <th style={{ width: "40%", border: "1px solid #dee2e6" }}>Product</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Stock</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Sale Price</th>
                <th style={{ width: "10%", textAlign: "center", border: "1px solid #dee2e6" }}>RRP</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Price After Discount</th>
                <th style={{ width: "5%", textAlign: "center", border: "1px solid #dee2e6" }}></th>
              </tr>
            </thead>
            <tbody
              style={{
                display: "block",
                // maxHeight: "340px",
                // overflowY: "auto"
              }}
            >
              {products.map((item, i) => (
                <tr key={i} style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                  <td style={{ width: "40%" }}>
                    <div className="row" style={{ padding: 5 }}>
                      <div className="col-md-4">
                        <img className="img-fluid" src={item.image || "https://via.placeholder.com/50"} width="50" alt="" />
                      </div>
                      <div className="col-md-8">
                        <p className="font-primary mb-0">{item.name}</p>
                        <p className="mb-0">
                          {item.colour ? `${item.colour} - ${item.size}` : `${item.size}`}
                        </p>
                        <p className="mb-0">{item.sku}</p>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{item.current_stock || 0}</td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.sale_price ?? 0).toFixed(2)}</td>
                  <td style={{ width: "10%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.price ?? 0).toFixed(2)}</td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>
                    {calculatePriceAfterDiscount(ourPercentage, item.price, item.price).toFixed(2)}
                  </td>
                  <td style={{ width: "5%", border: "1px solid #dee2e6", fontSize: "1rem" }}>
                    <a style={{ color: "red" }} onClick={() => onDelete(i)}>
                      <span className="fa fa-trash"></span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </Fragment>
  );
};

export default PartnerProductsJqx;
